import { render, staticRenderFns } from "./checkoutV5.vue?vue&type=template&id=5b948100&scoped=true"
import script from "./checkoutV5.vue?vue&type=script&lang=js"
export * from "./checkoutV5.vue?vue&type=script&lang=js"
import style0 from "./checkoutV5.vue?vue&type=style&index=0&id=5b948100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b948100",
  null
  
)

export default component.exports